export const V3_HOME_ICON_NAME = 'v3-home'
export const V3_MY_BETS_ICON_NAME = 'v3-my-bets'

export const V3_HOME_ICON =
	"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path d='M10,0,20,10V20H12.6V15H7.4v5H0V10Z'/></svg>"

export const V3_MY_BETS_ICON =
	"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path d='M14.06,0l.09,1.23L18.8,2l-.54,3.86-3.8-.62,1,12.26L14,17.62,12.74,0,0,1.09,1.4,20l11.46-1,4.5.74L20,1ZM1.41,6.36l-.29-4L11.8,1.45l.29,3.91Z'/></svg>"

export const V3_TAB_ICONS = {
	[V3_HOME_ICON_NAME]: V3_HOME_ICON,
	[V3_MY_BETS_ICON_NAME]: V3_MY_BETS_ICON,
}
